import "../../../src/App.css";
import React, { useState, useEffect } from "react";
import "../PettyCashHistory/PettyCashHistory.css";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import axios from "axios";
import { useRef } from "react";
import filterIcon from "../../Icons/filterIcon.png";
function PettyCashHistory() {

  const [formData, setFormData] = useState(null);
  const [fieldOpsResponse, setFieldOpsResponse] = useState(null);
  const [updatedFormData, setUpdatedFormData] = useState({
    Amount: null,
    Relocation_Id: "",
    Description: "",
    Expense_Type: "",
    Job_Id: null,
    Document: "",
    Created_By: "",
  });
  const [expense_Type, setExpense_Type] = useState([]);
  const [relocationIdPresent, setRelocationIdPresent] = useState(false);
  const baseAPI = process.env.REACT_APP_API_URL;
  const fileInputRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    console.log("location.search:", location.search);
    const relocationId = queryParams.get("Relocation_Id");
    
    if (relocationId !== null) {
      decryptRelocationID(relocationId);
      setRelocationIdPresent(true);
      getExpenseTypeList();
    } else {
      getFieldOpsList();
    }
  }, []);

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      getSelectedRelocationIdDetail(
        parseInt(bytes.toString(CryptoJS.enc.Utf8))
      );

      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      // setDecryptionError(true);

      return null;
    }
  }

  function getFieldOpsList() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}UserGet/GetFieldOpsDetail?RelocationId=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setFieldOpsResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      try {
        const response = await axios.post(
          `${baseAPI}Userpost/AddFieldOpsExpense?ExpenseId=0`,
          updatedFormData,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        alert("Expense successfully added");
        setUpdatedFormData({
          ...updatedFormData,
          Amount: "",
          Description: "",
          Expense_Type: "",
          Document: "",
          Job_Id: "",
        });
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } catch (error) {
        console.error("Error posting data:", error);
      }
    }
  };

  const handleChange = (type, e) => {
    const { name, value, files } = e.target;
    if (type === "get") {
      getSelectedRelocationIdDetail(parseInt(value));
      getExpenseTypeList();
    } else {
      if (name === "Document") {
        const file = files[0];
        getUpdatedDocument(file, name);
      } else {
        setUpdatedFormData({
          ...updatedFormData,
          [name]: value,
        });
      }
    }
  };

  function getUpdatedDocument(file, name) {
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const imageData = reader.result;
        setUpdatedFormData({
          ...updatedFormData,
          [name]: imageData,
        });
      };

      reader.readAsDataURL(file);
    }
  }

  function getSelectedRelocationIdDetail(id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}UserGet/GetFieldOpsDetail?RelocationId=${id}`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setFormData(response.data.data[0]);
          setUpdatedFormData({
            ...updatedFormData,
            Relocation_Id: response.data.data[0].Relocation_ID,
          });
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  function getExpenseTypeList() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}UserGet/GetFieldOpsExpenseTypeList`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setExpense_Type(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  function handleReset() {
    setUpdatedFormData({
      ...updatedFormData,
      Amount: "",
      Description: "",
      Expense_Type: "",
      Document: "",
      Job_Id: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }



  const data = [
    {
      id: "01",
      voucherNumber: "00000",
      date: "12 Dec 2024",
      leadID: "-",
      name: "Hitesh Gaur",
      cashReceived: "₹ 2,000",
      description: "-",
      amount: "₹ 990",
      remainingBalance: "₹ 1,010",
      remark: "-",
    },
  ];

  return (
    <>

      <div className="row">
        <div className="col-3"><button className="filterButton flex items-center" style={{ width: "30%" }}>
          <img src={filterIcon} alt="Filter Icon" className="mr-2" />
          FILTER
        </button></div>
        <div className="col-9" style={{ textAlign: "end" }}><button className="border  py-2 rounded-md" style={{ marginRight: "7px" }}>+ Add Expense</button>
          <button className="border  py-2 rounded-md" style={{ marginRight: "7px" }}>⬇ Download Excel</button>
          <button className="border  py-2 rounded-md">📜 LIST</button></div>
      </div>
      <div class="container-1 style1" style={styles1}>
        <div class="row">
          <div class="col-12">
            <h2 class="text-left" style={{ fontSize: "18px", padding: "9px 0 0 16px" }}>Add Expense</h2>
          </div>
        </div>




        <div class="row expense-rowms">
          <div class="col-md-3" style={{ display: "flex", flexDirection: "column" }}>
            <label className="label-expenseMs">Date of Expense</label>
            <input
              type="date"
              placeholder="Amount"
              className="amount-input"
              style={{ height: "54px", borderRadius: "5px", padding: "10px" }}
            // value={formData.amount}
            // onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
            />
          </div>
          <div className="col-md-6" style={{ display: "flex", flexDirection: "column" }}>
            <label className="label-expenseMs">Description</label>
            <select
              style={{
                border: "1px solid #5b489d",
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                marginBottom: "21px",
                marginTop: "1px",
                height: "54px",
                color: "#6a6a6a",
                position: "relative",
                marginLeft: "0px",
              }}
              className="form-control"
              name="Expense_Type"
              onChange={(event) => handleChange("insert", event)}
              required
              value={updatedFormData.Expense_Type}
            >
              <option value="0">Select an option</option>
              {expense_Type !== null
                ? expense_Type.map((item) => (
                  <option key={item.Tseed} value={item.Tseed}>
                    {item.TYPE}
                  </option>
                ))
                : null}
            </select>
          </div>

          <div class="col-md-3" style={{ display: "flex", flexDirection: "column" }}>
            <label className="label-expenseMs">Expense Amount</label>
            <input
              type="number"
              style={{
                border: "1px solid #5b489d",
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                marginBottom: "21px",
                marginTop: "1px",
                height: "54px",
                color: "#6a6a6a",
                position: "relative",
              }}
              name="Amount"
              onChange={(event) => handleChange("insert", event)}
              value={updatedFormData.Amount}
              placeholder="Please Enter*"
              required
            />
          </div>
        </div>

        <div className="row expense-rowms">
          <div class="col-md-6" style={{ display: "flex", flexDirection: "column" }}>
            <label className="label-expenseMs">Remark<span>(If Any)</span></label>
            <textarea
              placeholder="Please Enter*"
              className="label-expense-text Expense-input"
              name="Description"
              onChange={(event) => handleChange("insert", event)}
              value={updatedFormData.Description}
              required

              style={{ borderRadius: "5px", padding: "10px" }}

            />

          </div>
          <div className="col-md-3 rounded">
            <label htmlFor="fileInput" >Choose Document</label>
            <input
              type="file"
              style={{
                border: "1px solid #5b489d",
                width: "100%",
                padding: "7px",
                borderRadius: "6px",
                marginBottom: "21px",
                marginTop: "1px",
                height: "54px",
                color: "#6a6a6a",
                position: "relative",
              }}
              name="Document"
              ref={fileInputRef}
              onChange={(event) => handleChange("insert", event)}
              placeholder="Please Enter*"
              required
            />
          </div>
          <div className="col-md-3 rounded">
            <label htmlFor="fileInput" >Job ID</label>
            <input
              type="text"
              style={{
                border: "1px solid #5b489d",
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                marginBottom: "21px",
                marginTop: "1px",
                height: "54px",
                color: "#6a6a6a",
                position: "relative",
              }}
              name="Job_Id"
              onChange={(event) => handleChange("insert", event)}
              value={updatedFormData.Job_Id}
              placeholder="Please Enter*"
              required
            />
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-12">
          <h2 class="text-left" style={{ fontSize: "18px", padding: "9px 0 0 16px" }}>Account Details</h2>
        </div>
        <div style={{ marginTop: "5px", display: "flex", }}>
          <table className="leadlist_1 leadlist_2-Ms-table">
            <tr className="viewLeadDetailsHeading expenseHeading">
              <th>
                <span>Name</span>
              </th>
              <td style={{ borderBlock: "1px solid #ccc" }}>
                <span>Hitesh Gaur</span>
              </td>
              <th>
                <span>Department</span>
              </th>
              <td style={{ borderBlock: "1px solid #ccc" }}>
                <span>Operations</span>
              </td>
            </tr>
            <tr className="viewLeadDetailsHeading">
              <th>
                <span>Designation</span>
              </th>
              <td>
                <span>Team Leader - Operations</span>
              </td>
              <th>
                <span>Manager’s Name</span>
              </th>
              <td>
                <span>Digvijay Singh</span>
              </td>
            </tr>
            <tr className="viewLeadDetailsHeading">
              <th>
                <span>Petty Cash Number</span>
              </th>
              <td>
                <span>CMP-M2301</span>
              </td>
              <th>
                <span>Fixed Amount</span>
              </th>
              <td>
                <span>₹ 10,000</span>
              </td>
            </tr>
            <tr className="viewLeadDetailsHeading">
              <th>
                <span>Account Number</span>
              </th>
              <td>
                <span>0000000000000000</span>
              </td>
              <th>
                <span>IFSC</span>
              </th>
              <td>
                <span>--</span>
              </td>
            </tr>

          </table>
        </div>
      </div>
      <br></br>
      <table className="detailsTable">
        <tr className="employeeListHeading">
          <th className="p-2 border font-bold">#</th>
          <th className="p-2 border font-bold">Voucher Number</th>
          <th className="p-2 border font-bold">Date</th>
          <th className="p-2 border font-bold">Lead ID</th>
          <th className="p-2 border font-bold">Name</th>
          <th className="p-2 border font-bold">Cash Received</th>
          <th className="p-2 border font-bold">Description</th>
          <th className="p-2 border font-bold">Amount</th>
          <th className="p-2 border font-bold">Remaining Balance</th>
          <th className="p-2 border font-bold">Remark <i>(If Any)</i></th>
          <th className="p-2 border font-bold">View</th>
        </tr>


        <tbody>
          {data.map((row, index) => (
            <tr key={index} className="text-gray-800">
              <td className="p-2 border">{row.id}</td>
              <td className="p-2 border">{row.voucherNumber}</td>
              <td className="p-2 border">{row.First_Name}</td>
              <td className="p-2 border">{row.leadID}</td>
              <td className="p-2 border">{row.name}</td>
              <td className="p-2 border">{row.cashReceived}</td>
              <td className="p-2 border">{row.description}</td>
              <td className="p-2 border">{row.amount}</td>
              <td className="p-2 border text-green-600 font-bold">{row.remainingBalance}</td>
              <td className="p-2 border">{row.remark}</td>
              <td className="p-2 border text-center">
                <button className="bg-gray-100 p-2 rounded-md hover:bg-gray-300">
                  <FaExternalLinkAlt className="text-purple-600" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>

      </table>

    </>
  );
}

const styles1 = {


  margin: "0px 0 2rem 0px",
  padding: "1px 0 4rem 0"

}
export default PettyCashHistory;
